import { Outlet, Navigate } from 'react-router';

export default function ({ token, authorizedFirstScreen }) {
  return !token ? <Outlet /> : <Navigate to={authorizedFirstScreen} replace />;
}
